import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ButtonGroup, Button, Tabs, Tab, Box } from '@mui/material';
import SupportCoordinatorManagement from './SupportCoordinatorManagement';
import NewNote from '../SupportCoordinator/Modals/NewNote';
import NewTask from '../SupportCoordinator/Modals/NewTask';
import NewTimesheet from '../SupportCoordinator/Modals/NewTimesheet';
import Upload from '../SupportCoordinator/Modals/Upload';
import SupportCoordinatorCustomers from '../SupportCoordinator/SupportCoordinatorCustomers';
import Home from '../../components/Home/HomeBox'
import GridLayoutComponent from 'src/components/GridLayoutComponent/GridLayoutComponent';
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../config';

function SupportCoordinatorSupervisorHome(props) {
    const [dataLoading, setDataLoading] = useState(true);
    const [sDataLoading, setSDataLoading] = useState(true);
    const [value, setValue] = useState('1');
    const [data, setData] = useState(null);
    const [sData, setSData] = useState(null);

    const [showAddNote, setShowAddNote] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [showTask, setShowTask] = useState(false);
    const [showTimesheet, setShowTimesheet] = useState(false);

    const [noteCustomerID, setNoteCustomerID] = useState();
    const [uploadCustomerID, setUploadCustomerID] = useState("");
    const [timesheetCustomerID, setTimesheetCustomerID] = useState("")

    const fetchRowsRef = useRef(null);
    const registerFetchRows = useCallback((fetcher) => {
        fetchRowsRef.current = fetcher || null;
    }, []);

    const handleShowNote = (id) => { setNoteCustomerID(id); setShowAddNote(true) };
    const handleShowUpload = (id) => { setUploadCustomerID(id); setShowUpload(true) };
    const handleShowTask = () => setShowTask(true);
    const handleCloseTask = () => setShowTask(false);
    const handleShowTimesheet = (id) => { setTimesheetCustomerID(id); setShowTimesheet(true) };
    const handleCloseTimesheet = () => setShowTimesheet(false);

    const isSubscibedToTimeManagement = props.user.subs.find((setting) => setting.feature_id === 12) ? true : false;

    const getEmployees = async () => {
        console.log(props.comp_id);
        console.log(props.user);
        let data = await axios.get(APIURL + "/monthlymonitoring/manager/data", {
            params: {
                comp_id: props.comp_id,
                emp_id: props.user.emp_id,
                start: moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD'),
                end: moment().endOf('month').format('YYYY-MM-DDT23:59:59'),
            }
        });

        setData(data.data);
        console.log(data.data);
        setDataLoading(false);
    }

    const getSCH = async () => {
        let data = await axios.get(APIURL + "/customers/SCH", {
            params: {
                comp_id: props.comp_id,
                emp_id: props.user.emp_id,
                start: moment().subtract(11, 'months').startOf('month').format('YYYY-MM-DD'),
                end: moment().endOf('month').format('YYYY-MM-DD'),
            }
        });
        setSData(data.data)
        setSDataLoading(false);
        console.log(data.data)
    }

    useEffect(() => {
        const fetchData = async () => {
            props.checkTokenExpiry();
            await getEmployees();
        };
        fetchData();
    }, [props])

    const handleTimesheetCreated = () => {
        fetchRowsRef.current?.({ skipCache: true });
        getEmployees();
    };

    return (
        <div>
            <Tabs
                sx={{ width: '100%' }}
                indicatorColor="primary"
                textColor="primary"
                value={value}>
                <Tab onClick={() => setValue('1')} label="Home" value="1" />
                {/* <Tab onClick={() => setValue('2')} label="SC MANAGEMENT" value="2" /> */}
                <Tab onClick={() => setValue('3')} label="CUSTOMERS" value="3" />
                <Tab onClick={() => setValue('4')} label="DASHBOARD" value="4" />
                <Box sx={{ display: 'inline-flex', justifyContent: 'flex-end', width: "100%", marginBottom: 1 }}>
                    <ButtonGroup size="small" style={{ marginRight: 10 }}>
                        <Button variant="contained" onClick={() => setShowAddNote(true)}>NEW NOTE</Button>
                        <Button variant="contained" onClick={handleShowTask}>NEW TASK</Button>
                        {isSubscibedToTimeManagement && <Button variant="contained" onClick={handleShowTimesheet}>NEW TIMESHEET</Button>}
                        <Button size="small" variant="contained" onClick={() => setShowUpload(true)}>UPLOAD</Button>
                    </ButtonGroup>
                </Box>
            </Tabs>
            {value === '1' &&
                <GridLayoutComponent
                    {...props}
                    checkTokenExpiry={props.checkTokenExpiry}
                    user={props.user}
                    comp_id={props.comp_id}
                    onRegisterFetchRows={registerFetchRows}
                    handleShowNote={handleShowNote}
                    handleShowUpload={handleShowUpload}
                    handleShowTimesheet={handleShowTimesheet}
                    sData={sData ? sData : []}
                    sDataLoading={sDataLoading}
                    data={data ? data : []}
                    getSCH={getSCH}
                    getEmployees={getEmployees}
                    dataLoading={dataLoading}
                />
            }
            {value === '2' &&
                <div>
                    <SupportCoordinatorManagement
                        {...props}
                        handleShowNote={handleShowNote}
                        handleShowUpload={handleShowUpload}
                        data={data ? data : []}
                        comp_id={props.comp_id}
                        emp_id={props.user.emp_id}
                        getSCH={getSCH}
                        getEmployees={getEmployees}
                        loading={dataLoading}
                    />
                </div>
            }
            {value === '3' &&
                <div>
                    <SupportCoordinatorCustomers
                        {...props}
                        handleShowNote={handleShowNote}
                        handleShowUpload={handleShowUpload}
                        handleShowTimesheet={handleShowTimesheet}
                        onRegisterFetchRows={registerFetchRows}
                        data={sData ? sData : []}
                        comp_id={props.comp_id}
                        emp_id={props.user.emp_id}
                        loading={sDataLoading}
                        isSubscibedToTimeManagement={isSubscibedToTimeManagement}
                    />
                </div>
            }
            {value === '4' &&
                <div >
                    <Home {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                </div>
            }
            <div>
                <NewNote showAddNote={showAddNote} setShowAddNote={setShowAddNote} company_id={props.comp_id} mode='add' user={props.user} customer_id={noteCustomerID} setNoteCustomerID={setNoteCustomerID}></NewNote>
                <NewTask show={showTask} handleClose={handleCloseTask} user={props.user} emp_id={props.user.emp_id} comp_id={props.comp_id} {...props} />
                {isSubscibedToTimeManagement && <NewTimesheet show={showTimesheet} handleClose={handleCloseTimesheet} comp_id={props.comp_id} user={props.user} emp_id={props.user.emp_id} customer_id={timesheetCustomerID} setTimesheetCustomerID={setTimesheetCustomerID} onTimesheetCreated={handleTimesheetCreated}></NewTimesheet>}
                <Upload showUpload={showUpload} setShowUpload={setShowUpload} company_id={props.comp_id} user={props.user} customer_id={uploadCustomerID} setUploadCustomerID={setUploadCustomerID} rerender={getSCH}></Upload>
            </div>
        </div>
    )
}

export default SupportCoordinatorSupervisorHome;